import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import CardPost from "./CardPost";
import { FormControlLabel } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { Row, Col, Container } from "react-bootstrap";
import dayjs from "dayjs";
import AnimatedLoading from "components/Loading/aminateLoading";
import ArchiveSwitch from "components/archiveSwich/archiveSwich";
import { ThemeProvider } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import CustomPagination from "views/client/pagination";
import NoArchivedPosts from "./NoArchivedPosts";
import { PostButton } from "components/Buttons/Buttons";
import { PostSearchBar } from "components/searchBars/SearchBars";
import { SearchButton } from "components/Buttons/Buttons";
import { TitleTypography } from "StyledTypography/StyledTypography";
import { useSnackbar } from "hooks/useSbackbar";
import PostDetailsDialog from "./Dialogs/PostDetails";
import WorkingDetailsDialog from "./Dialogs/WorkingDetailsDialog";
import RecruiterCandidatesApplications from "views/Candidates/RecruiterCandidatesApplications ";
import RecruiterCandidatesApplicationsPDF from "views/Candidates/RecruiterCandidatesApplicationsPDF";
import { useTranslation } from "react-i18next";
import colors from "colors/color";
import addIcon from "../../assets/img/add_icon.svg";
import filterIcon from "../../assets/img/filter_icon.svg";
import searchIcon from "../../assets/img/search_icon_grey.svg";
import PersonalInforamtions from "views/client/PersonalInforamtions";
import PersonalBiography from "views/client/PersonalBiography";
import PasswordSettings from "views/client/PasswordSettings";
import PublishedOffers from "./PublishedOffers";
import ArchivedPosts from "./ArchivedOffers";
import useLinkedInPost from "./hooks/LinkedInPost";
import NewSearchBar from "components/searchBars/NewSearchBar";
import { useTour } from "context/TourContext";

const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;

const PostPage = () => {
  const [postImage, setPostImage] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [ref] = useState(false);
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = React.useState(null);
  const [publishedPosts, setPublishedPosts] = useState([]);
  const [archivedPosts, setArchivedPosts] = useState([]);
  const [publishedFilter, setPublishedFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const linkedInPost = useLinkedInPost();
  const theme = useTheme();
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = getUserIdFromAccessToken();
  const [errors, setErrors] = useState({});
  const [offerType, setOfferType] = useState("");
  const [location, setLocation] = useState(null);
  const [numPeople, setNumPeople] = useState(null);
  const [salary, setSalary] = useState(null);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [workingMode, setWorkingMode] = useState("");
  const [currency, setCurrency] = useState("MAD");
  const client_id = "86dpwd87p8nanb";
  const secret_id = process.env.LINKEDIN_CLIENT_SECRET;
  const [loading, setLoading] = useState(true);
  const [postId, setPostId] = useState("");
  const navigate = useNavigate();

  // Tour state
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);

  // Pagination for published posts
  const [publishedPage, setPublishedPage] = useState(1);
  const [publishedRowsPerPage, setPublishedRowsPerPage] = useState(9);
  const [totalPublishedPosts, setTotalPublishedPosts] = useState(0);

  // Pagination for archived posts
  const [archivedPage, setArchivedPage] = useState(1);
  const [archivedRowsPerPage, setArchivedRowsPerPage] = useState(9);
  const [totalArchivedPosts, setTotalArchivedPosts] = useState(0);

  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [experience, setExperience] = useState("");
  const { t } = useTranslation();
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [dateError, setDateError] = useState("");
  const [tableType, setTableType] = useState("Published_offers");
  const [reference, setReference] = useState("");
  const [recruiterEmail, setRecruiterEmail] = useState("");
  const [accountType, setAccountType] = useState("");
  const [normalizedCoefficients, setNormalizedCoefficients] = useState(null);
  const [quiz, setQuiz] = useState(null);
  // const [isCheckedScr, setIsCheckedScr] = useState(false);
  const convertCoefficientsToNumbers = (coeffs) => {
    if (!coeffs) return null;

    const converted = {};
    for (const [key, value] of Object.entries(coeffs)) {
      converted[key] = parseFloat(value);
    }
    return converted;
  };
  const handlePostClick = (post) => {
    const encodedId = btoa(post.id);
    if (post.scraped) {
      navigate(`/talent/post/scraped/${encodedId}`, { replace: true });
    } else {
      navigate(`/talent/post/${encodedId}`, { replace: true });
    }
  };
  const [updatedData, setUpdatedData] = useState({
    postTitle: "",
    postDescription: "",
    offerType: "",
    postRequirement: "",
    postDeadline: "",
    accountType: "",
    reference: "",
    recruiterEmail: "",
    postId: "",
    postImage: "",
    location: "",
    numPeople: "",
    workingMode: "",
    salary: "",
    currency: "",
    fieldOfStudy: "",
    otherFieldOfStudy: "",
    experience: "",
    diploma: "",
    otherDiploma: "",
    isCheckedScr: false,
  });

  const { startTour, startTourForRoute, completedTours } = useTour();

  // Define tour steps for the offers page
  const offersTourSteps = [
    {
      target: '.search-bar-container',
      content: t('tour.search'),
      title: t('tour.Search Offers'),
      placement: 'bottom',
      disableBeacon: true,

    },
    {
      target: '.create-offer-btn',
      content: t('tour.create_offer'),
      title: t('tour.Create New Offer'),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.filter-offer-btn',
      content: t('tour.filter_button'),
      title: 'Filter Offers',
      placement: 'bottom',
      disableBeacon: true,
    },

    {
      target: '.offers-tabs',
      content: t('tour.offers_tabs'),
      title: t('tour.Offers Tabs'),
      placement: 'bottom',
      disableBeacon: true,
    },
  ];

  // Check if this is the user's first visit to the offers page
  // useEffect(() => {
  //   const hasSeenOffersTour = localStorage.getItem('tour_/post/PostDetails');

  //   if (!hasSeenOffersTour) {
  //     console.log('Showing offers tour1',hasSeenOffersTour)
  //     // Set up the tour steps
  //     // setTourSteps(offersTourSteps);
  //     // startTourForRoute('/post/PostDetails');
  //     startTour(offersTourSteps,'/post/PostDetails');
  //     // Small delay to ensure all elements are rendered
  //     const timer = setTimeout(() => {
  //       setRunTour(true);
  //     }, 1000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [startTour]);

  const handleTourCallback = (data) => {
    const { status } = data;

    // Tour finished or skipped
    if (status === 'finished' || status === 'skipped') {
      setRunTour(false);
      // Mark tour as completed in localStorage
      localStorage.setItem('tour_/post/PostDetails', 'true');
    }
  };

  const handleDateChange = (newValue) => {
    const dateOnly = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;

    if (newValue && dayjs(newValue).isBefore(dayjs().add(1, "day"), "day")) {
      setDateError(t("errors.dateMustBeTomorrowOrLater"));
      setPostDeadline(null);
    } else {
      setDateError("");
      setPostDeadline(dateOnly);
    }
  };

  const convertOfferType = (type) => {
    return type === "internship" ? "i" : "j";
  };

  const validateFirstDialog = () => {
    let tempErrors = {};
    tempErrors.postTitle = postTitle ? "" : t("postPage.errors.postTitle");
    tempErrors.postDescription = postDescription
      ? ""
      : t("postPage.errors.postDescription");
    tempErrors.postRequirement =
      postRequirement.length > 0 ? "" : t("postPage.errors.postRequirement");
    tempErrors.postDeadline = postDeadline
      ? ""
      : t("postPage.errors.postDeadline");
    tempErrors.offerType = offerType ? "" : t("postPage.errors.offerType");
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const validateSecondDialog = () => {
    let tempErrors = {};
    tempErrors.location = location ? "" : t("postPage.errors.location");
    tempErrors.workingMode = workingMode
      ? ""
      : t("postPage.errors.workingMode");
    tempErrors.postImage = postImage ? "" : t("postPage.errors.postImage");
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleNext = () => {
    if (validateFirstDialog()) {
      setOpen(false);
      setOpen2(true);
    }
  };

  const handleSave = () => {
    if (validateSecondDialog()) {
      save();
    }
  };

  useEffect(() => {
    const handleAuthMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      const { code } = event.data;
      if (code) {
        fetchCallbackData(code);
      }
    };

    window.addEventListener("message", handleAuthMessage, false);

    return () => {
      window.removeEventListener("message", handleAuthMessage, false);
    };
  }, []);

  const handleLinkedInAuth = () => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/talent/post/PostDetails/`
    );
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&scope=openid%20email%20profile%20w_member_social`;
    const newWindow = window.open(linkedInAuthUrl, "_blank");

    window.addEventListener("message", handleAuthMessage, false);

    function handleAuthMessage(event) {
      if (event.origin !== window.location.origin) return;

      const { code } = event.data;
      if (code) {
        window.removeEventListener("message", handleAuthMessage);
        newWindow.close();
      }
    }
  };

  const fetchCallbackData = async (code) => {
    try {
      const response = await axios.get(
        `${apiUrl}authentication/linkedin_callback_post/`,
        {
          params: { code: code },
        }
      );
      localStorage.setItem(
        "accessToken_LinkedIn",
        response.data.linkedIn_access_token
      );
      localStorage.setItem(
        "linkedin_person_id",
        response.data.linkedin_person_id
      );
      handleCreatePost(
        response.data.linkedIn_access_token,
        response.data.linkedin_person_id
      );
      resetForm();
    } catch (error) {
      console.error("Error fetching data from callback:", error);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      fetchCallbackData(code);
    }
  }, []);

  const handleCreatePost = async (token, personnalId) => {
    const formData = JSON.parse(localStorage.getItem("postFormData"));
    if (!formData) {
      console.error("Form data not found in localStorage!");
      return;
    }

    const {
      postImage,
      postTitle,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      numPeople,
      workingMode,
      salary,
      currency,
      offerType,
      postId,
    } = formData;

    if (
      !postTitle ||
      !postDeadline ||
      !location ||
      !postDescription ||
      !postRequirement
    ) {
      toast.error(t("postPage.errors.missingFields"));
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}authentication/linkedin/post-create/`,
        {
          token: token,
          personnalId: personnalId,
          subject: postTitle,
          lien: `${apiUrlFront}viewjob/${postId}`,
          postDeadline: postDeadline,
          location: location,
          postImage: postImage,
          postDescription: postDescription,
          requirement: postRequirement,
          workMode: workingMode,
          salary: salary || null,
          numToHire: numPeople || null,
          currency: currency,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      toast.success(t("postPageMeta.success.postCreated"));
      resetForm();
      localStorage.removeItem("linkedin_person_id");
      localStorage.removeItem("accessToken_LinkedIn");
      localStorage.removeItem("postFormData");

      if (window.opener) {
        window.opener.postMessage(
          { action: "postCreated" },
          window.location.origin
        );
        window.close();
      }
    } catch (error) {
      console.error("Error creating post:", error);
      toast.error(t("postPage.errors.postCreationFailed"));
    }
  };

  const getFilteredPosts = (posts, filter) => {
    return posts.filter((post) => {
      const job = post.title.toLowerCase();
      const filterLower = filter.toLowerCase();
      return job.includes(filterLower);
    });
  };

  const filteredPublishedPosts = getFilteredPosts(
    publishedPosts,
    publishedFilter
  );
  const filteredArchivedPosts = getFilteredPosts(archivedPosts, archivedFilter);

  useEffect(() => {
    window.addEventListener("message", handlePostCreatedMessage);
    return () => {
      window.removeEventListener("message", handlePostCreatedMessage);
    };
  }, []);

  const handlePostCreatedMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data.action === "postCreated") {
      loadPosts();
      toast.success(t("postPageMeta.success.postCreated"));
    }
  };

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      const userId = decodedToken.user_id;
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  useEffect(() => {
    console.log("publishedPosts", publishedPosts);
  }, []);
  const loadPublishedPosts = async (updatedPosts = null) => {
    // If we have updated posts directly, use them instead of fetching


    try {
      const response = await fetch(
        `${apiUrl}posts/list/${userId}/?page=${publishedPage}&page_size=${publishedRowsPerPage}&filter=${publishedFilter}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();
      console.log('✅ API response received:', json.results.length, 'posts');
      for (let i = 0; i < json.results.length; i++) {
        console.log("json.results[i]", json.results[i]);
        if (json.results[i].company_logo !== null) {
          setCompanyLogo(json.results[i].company_logo);
          setCompany(json.results[i].company);
          break;
        }
        console.log("companyLogo", i, json.results[i].company_logo);
      }
      console.log('🔄 Setting published posts state...');
      setPublishedPosts(json.results);
      setTotalPublishedPosts(json.count);
      console.log("updatedPosts==:", json.results);
      if (updatedPosts) {
        console.log('🔄 Using updatedPosts instead of API results');
        setPublishedPosts(updatedPosts);
        // return;
      }
      console.log('✅ loadPublishedPosts completed successfully');
    } catch (error) {
      console.error("Error loading published posts:", error);
      setPublishedPosts([]);
      setTotalPublishedPosts(0);
    }
  };

  const [companyLogo, setCompanyLogo] = useState("");
  const [company, setCompany] = useState("");
  const loadArchivedPosts = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${apiUrl}posts/list/${userId}/all/?page=${archivedPage}&page_size=${archivedRowsPerPage}&filter=${archivedFilter}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setLoading(false);
      const json = await response.json();
      for (let i = 0; i < json.results.length; i++) {
        console.log("json.results[i]", json.results[i]);
        if (json.results[i].company_logo !== null) {
          setCompanyLogo(json.results[i].company_logo);
          setCompany(json.results[i].company);
          break;
        }
        console.log("companyLogo", i, json.results[i].company_logo);
      }
      console.log("json.results", json.results);
      setArchivedPosts(json.results);

      setTotalArchivedPosts(json.count);
    } catch (error) {
      console.error("Error loading archived posts:", error);
      setArchivedPosts([]);
      setTotalArchivedPosts(0);
    }
  };
  const { archived } = useLocation().state || { archived: false };

  useEffect(() => {
    if (archived) {
      setTableType("Archived_offers");
    }
  }, [archived])
  const loadPosts = async () => {
    setLoading(true);
    if (tableType === "Published_offers") {
      await loadPublishedPosts();
    } else {
      await loadArchivedPosts();
    }

    setLoading(false);
  };

  const handleChangePublishedPage = (event, newPage) => {
    setPublishedPage(newPage + 1);
  };

  const handleChangePublishedRowsPerPage = (event) => {
    setPublishedRowsPerPage(parseInt(event.target.value, 10));
    setPublishedPage(1);
  };

  const handleChangeArchivedPage = (event, newPage) => {
    setArchivedPage(newPage + 1);
  };

  const handleChangeArchivedRowsPerPage = (event) => {
    setArchivedRowsPerPage(parseInt(event.target.value, 10));
    setArchivedPage(1);
  };
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };


  useEffect(() => {
    console.log("coefficients changed:", convertCoefficientsToNumbers(normalizedCoefficients));
  }, [normalizedCoefficients]);

  useEffect(() => {
    loadPosts();
  }, [
    tableType,
    publishedPage,
    publishedRowsPerPage,
    archivedPage,
    archivedRowsPerPage,
  ]);

  async function save() {
    setOpen2(false);
    const formData = {
      postImage,
      postTitle,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      workingMode,
      currency,
      offerType,
    };

    try {
      setLoading(true);
      if (isCheckedScr) {
        var response = await axios.post(`${apiUrl}posts/create/`, {
          image: postImage,
          title: postTitle,
          reference: reference,
          accountType: accountType,
          description: postDescription,
          requirements: postRequirement,
          deadline: postDeadline,
          recruiter: userId,
          mode: workingMode,
          salary: salary || null,
          age_experience: numPeople || null,
          scraped: isCheckedScr,
          currency: currency,
          localisation: location,
          offerType: convertOfferType(offerType),
          education: `${diploma || otherDiploma} ${fieldOfStudy || otherFieldOfStudy
            }`,
          experiences: stripHtmlTags(postDescription),
          recruiter_email: recruiterEmail,
          coefficients: convertCoefficientsToNumbers(normalizedCoefficients),
          quiz: quiz
        });
      } else {
        var response = await axios.post(`${apiUrl}posts/create/`, {
          image: postImage,
          title: postTitle,
          description: postDescription,
          requirements: postRequirement,
          deadline: postDeadline,
          recruiter: userId,
          mode: workingMode,
          salary: salary || null,
          age_experience: numPeople || null,
          scraped: isCheckedScr,
          currency: currency,
          localisation: location,
          offerType: convertOfferType(offerType),
          education: `${diploma || otherDiploma} ${fieldOfStudy || otherFieldOfStudy
            }`,
          highest_diploma: diploma || otherDiploma,
          field_of_study: fieldOfStudy || otherFieldOfStudy,
          experiences: stripHtmlTags(postDescription),
          coefficients: convertCoefficientsToNumbers(normalizedCoefficients),
          quiz: quiz
        });
      }


      const newPostId = response.data.id;
      setPostId(newPostId);
      formData.postId = btoa(newPostId);

      if (isChecked) {
        linkedInPost.handleLinkedInAuth(formData);
      }

      resetForm();
      setTableType("Published_offers"); // Switch to published offers tab after creating
      console.log('🔄 Post created successfully, refreshing posts list...');
      await loadPosts();
      console.log('✅ Posts list refreshed after creation');
      toast.success(t("postPageMeta.success.postCreated"));
    } catch (err) {
      console.error("Post Registration Failed:", err);
      if (err.response) {
        toast.error(
          `Post Registration Failed: ${err.response.data.message || err.response.statusText
          }`
        );
      } else if (err.request) {
        toast.error(
          "Post Registration Failed: No response received from server"
        );
      } else {
        toast.error(`Post Registration Failed: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  }

  const resetForm = () => {
    setPostTitle("");
    setPostDescription("");
    setPostRequirement([]);
    setOfferType("");
    setPostDeadline("");
    setPostImage("");
    setSalary("");
    setNumPeople("");
  };

  const handleImageUpload = (postImage) => {
    setPostImage(postImage);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const { showSnackbar } = useSnackbar();

  const deletePostById = async (postId) => {
    try {
      await axios.delete(`${apiUrl}posts/${postId}/delete/`);
      loadPosts();
      showSnackbar(t("postPage.success.postDeleted"), "success");
    } catch (error) {
      showSnackbar(t("postPage.errors.postDeletionFailed"), "error");
    }
  };

  useEffect(() => {
    console.log("updatedData==>", updatedData);
    if (updatedData.postId) {
      updatePost();
    }
  }, [updatedData]);

  const updatePost = async () => {
    console.log("it's been called here 54!!, :", updatedData)
    try {
      const response = await axios.put(
        `${apiUrl}posts/${updatedData.postId}/update/`,
        updatedData
      );

      if (response.status === 200) {
        const updatedPost = response.data;

        // Update publishedPosts if the post exists there
        setPublishedPosts(prevPosts =>
          prevPosts.map(post =>
            post.id === updatedData.postId ? { ...post, ...updatedPost } : post
          )
        );

        // Update archivedPosts if the post exists there
        setArchivedPosts(prevPosts =>
          prevPosts.map(post =>
            post.id === updatedData.postId ? { ...post, ...updatedPost } : post
          )
        );

        toast.success(t("postPage.success.postUpdated") || "Post updated successfully");
      }
    } catch (error) {
      console.error(`Error updating post: ${error.message}`);
      toast.error(t("postPage.errors.postUpdateFailed") || "Failed to update post");
    }
  };

  const handleSelectPost = (post) => {
    setSelectedPost(post);
  };

  const handleBackToList = () => {
    setSelectedPost(null);
  };

  const handleSalaryChange = (value) => {
    setSalary(value ? parseFloat(value) : null);
  };

  const onArchivePost = async (postId, archivedStatus) => {
    try {
      const post =
        publishedPosts.find((p) => p.id === postId) ||
        archivedPosts.find((p) => p.id === postId);

      if (post && new Date(post.deadline) < new Date()) {
        toast.warning(t("postPage.warnings.deadlineChangeRequired"));
        return;
      }

      const response = await fetch(
        `${apiUrl}posts/${postId}/archive/${userId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
          body: JSON.stringify({ archived: archivedStatus }),
        }
      );
      if (response.ok) {
        loadPosts();
        toast.success(
          t(
            `postPage.success.${archivedStatus ? "postArchived" : "postUnarchived"
            }`
          )
        );
      } else {
        toast.error(t("postPage.errors.archiveUpdateFailed"));
      }
    } catch (error) {
      console.error(`Error updating archive status: ${error.message}`);
      toast.error(t("postPage.errors.archiveUpdateFailed"));
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  const handleTableTypeChange = (event, newValue) => {
    setTableType(newValue);
    // Reset filter when switching tabs
    if (newValue === "Published_offers") {
      setPublishedFilter("");
    } else {
      setArchivedFilter("");
    }
  };

  const handleSearch = () => {
    loadPosts();
  };

  const renderTable = () => {
    switch (tableType) {
      case "Published_offers":
        return (
          <PublishedOffers
            posts={publishedPosts}
            filter={publishedFilter}
            filteredCards={filteredPublishedPosts}
            onArchivePost={onArchivePost}
            deletePostById={deletePostById}
            updatePost={updatePost}
            handlePostClick={handlePostClick}
            totalPosts={totalPublishedPosts}
            page={publishedPage - 1}
            rowsPerPage={publishedRowsPerPage}
            handleChangePage={handleChangePublishedPage}
            handleChangeRowsPerPage={handleChangePublishedRowsPerPage}
            loadPublishedPosts={loadPublishedPosts}
            companyLogo={companyLogo}
            company={company}
          />
        );
      case "Archived_offers":
        return (
          <ArchivedPosts
            posts={archivedPosts}
            filter={archivedFilter}
            filteredCards={filteredArchivedPosts}
            onArchivePost={onArchivePost}
            deletePostById={deletePostById}
            updatePost={updatePost}
            handlePostClick={handlePostClick}
            totalPosts={totalArchivedPosts}
            page={archivedPage - 1}
            rowsPerPage={archivedRowsPerPage}
            handleChangePage={handleChangeArchivedPage}
            handleChangeRowsPerPage={handleChangeArchivedRowsPerPage}
            loadArchivedPosts={loadArchivedPosts}
            companyLogo={companyLogo}
            company={company}
            loading={loading}
          />
        );
      default:
        return <PublishedOffers />;
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <NewSearchBar

          // className="search-bar-container"
          filter={
            tableType === "Published_offers" ? publishedFilter : archivedFilter
          }
          setFilter={
            tableType === "Published_offers"
              ? setPublishedFilter
              : setArchivedFilter
          }
          setOpen={setOpen}
          t={t}
          searchIcon={searchIcon}
          addIcon={addIcon}
          filterIcon={filterIcon}
          PostSearchBar={PostSearchBar}
          handleSearch={handleSearch}
        />
      </Box>
      <Box sx={{ position: "relative", marginLeft: 5, marginBottom: 4 }}>
        {/* Static gray line */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2.5px",
            backgroundColor: "divider",
            zIndex: 0,
          }}
        />

        <Tabs
          className="offers-tabs"
          value={tableType}
          onChange={handleTableTypeChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTabs-indicator": {
              height: "2px",
              zIndex: 1,
            },
            "& .MuiTab-root": {
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "14px",
            },
          }}
        >
          <Tab
            label={t("postPage.tabs.publishedOffers")}
            sx={{ fontFamily: "Poppins", textTransform: "none" }}
            value="Published_offers"
          />
          <Tab
            label={t("postPage.tabs.closedOffers")}
            sx={{ fontFamily: "Poppins", textTransform: "none" }}
            value="Archived_offers"
          />
        </Tabs>
      </Box>
      {/* {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <CircularProgress />
        </Box>
      ) : ( */}
      {renderTable()}
      {/* )} */}
      <PostDetailsDialog
        setOpen={setOpen}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        postDescription={postDescription}
        setPostDescription={setPostDescription}
        offerType={offerType}
        setOfferType={setOfferType}
        postRequirement={postRequirement}
        setPostRequirement={setPostRequirement}
        postDeadline={postDeadline}
        handleDateChange={handleDateChange}
        handleNext={handleNext}
        open={open}
        errors={errors}
        // setIsCheckedScrPost={setIsCheckedScr}
        setReference={setReference}
        setRecruiterEmail={setRecruiterEmail}
        setAccountType={setAccountType}
        isCheckedScr={isCheckedScr}
        setIsCheckedScr={setIsCheckedScr}
        setUpdatedData={setUpdatedData}
      />
      <WorkingDetailsDialog
        setOpen2={setOpen2}
        setOpen={setOpen}
        open2={open2}
        errors={errors}
        handleImageUpload={handleImageUpload}
        setWorkingMode={setWorkingMode}
        workingMode={workingMode}
        location={location}
        setLocation={setLocation}
        setErrors={setErrors}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        salary={salary}
        handleSalaryChange={handleSalaryChange}
        currency={currency}
        setCurrency={setCurrency}
        isChecked={isChecked}
        handleCheckboxChange={handleCheckboxChange}
        isCheckedScr={isCheckedScr}
        setIsCheckedScr={setIsCheckedScr}
        handleCheckboxChangeScr={handleCheckboxChangeScr}
        handleSave={handleSave}
        fieldOfStudy={fieldOfStudy}
        setFieldOfStudy={setFieldOfStudy}
        otherFieldOfStudy={otherFieldOfStudy}
        setOtherFieldOfStudy={setOtherFieldOfStudy}
        experience={experience}
        setExperience={setExperience}
        diploma={diploma}
        setDiploma={setDiploma}
        otherDiploma={otherDiploma}
        setOtherDiploma={setOtherDiploma}
        onNormalizedCoefficientsChange={setNormalizedCoefficients}
        onQuizChange={setQuiz}
      />
    </>
  );
};

export default PostPage;
